<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
      :key="keyChange"
    >
      <a-form-model-item label="Plate / Biển số xe" prop="plate">
        <a-input v-model="form.plate" placeholder="Enter text..." />
      </a-form-model-item>
      <a-form-model-item label="Model / Đời xe" prop="model">
        <a-input v-model="form.model" placeholder="Enter text..." />
      </a-form-model-item>
      <a-form-model-item label="Seat / Số chỗ ngồi" prop="seat">
        <a-input-number
          v-model="form.seat"
          placeholder="Enter number..."
          :formatter="
            (value) =>
              +value >= 0 && +value % 1 === 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item label="Location / Địa điểm làm việc" prop="locationId">
        <SelectLocation
          v-model="form.locationId"
          :initial-datas="form.location ? [form.location] : null"
          :select-props="{
            value: form.locationId || undefined,
            placeholder: 'Choose location',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Vehicle type / Loại xe" prop="vehicleTypeId">
        <SelectVehicleType
          v-model="form.vehicleTypeId"
          :initial-datas="form.vehicleType ? [form.vehicleType] : null"
          :select-props="{
            value: form.vehicleTypeId || undefined,
            placeholder: 'Choose vehicle type',
          }"
        />
      </a-form-model-item>

      <a-form-model-item label="Driver / Tài xế" prop="driverEmployeeId">
        <SelectEmployee
          v-model="form.driverEmployeeId"
          :initial-datas="form.driverEmployee ? [form.driverEmployee] : null"
          :selectProps="{
            value: form.driverEmployeeId || undefined,
            placeholder: 'Choose employee',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Note / Ghi chú">
        <a-textarea v-model="form.note" placeholder="Enter text..." :rows="4" />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Add New
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
import moment from "moment";

const rules = {
  plate: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  vehicleTypeId: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
};
const defaultForm = {};

export default {
  components: {
    SelectLocation: () => import("@/components/common/branchLocation/select"),
    SelectEmployee: () => import("@/components/common/employee/select"),
    SelectVehicleType: () => import("@/components/common/vehicleType/select"),
  },
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...defaultForm },
      loading: false,
      keyChange: 0,
    };
  },
  methods: {
    moment,
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedVehicle();
        } else {
          return false;
        }
      });
    },
    onCreatedVehicle() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createVehicle,
          variables: {
            ...this.form,
            startDate: this.form.startDate
              ? moment(this.form.startDate).set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                })
              : undefined,
            endDate: this.form.endDate
              ? moment(this.form.endDate).set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                })
              : undefined,
            year: this.form.startDate
              ? +new Date(this.form.startDate).getFullYear()
              : undefined,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createVehicle?.id) {
            this.refreshAfterCreated(data.createVehicle);
          }
          this.keyChange += 1;
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Thêm thông tin không thành công", err);
        });
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
